import { Button, Flex } from 'antd';
import React from 'react';
import './style.css';
import { PlusOutlined } from '@ant-design/icons';

interface ButtonAddPlusProps {
    onClick: (e: any) => void;
}

const ButtonAddPlus: React.FC<ButtonAddPlusProps> = ({ onClick }) => (
    <Flex gap="small" wrap="wrap" className="flex">
        <Button
            className="button-type-primary button-size-medium_icon"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick(e);
            }}
        >
            <PlusOutlined />
        </Button>
    </Flex>
);

export default ButtonAddPlus;
